import * as Sentry from '@sentry/browser';
import { ApiResourceName } from '@shared/types/api/api';
import { fetchResourceCollection, newListFilters, newListSorting } from '@backoffice/utils/api';
import { SortDirection } from '@backoffice/types/sort';
import { USERS_PER_PAGE, USERS_FILTERS_MAPPING, USERS_SORTING_MAPPING, } from '@backoffice/types/store';
export const name = 'users';
export const namespaced = true;
export const state = () => ({
    users: [],
    total: 0,
    loading: false,
    page: 1,
    filters: newListFilters(),
    sorting: newListSorting('lastname', SortDirection.Asc),
});
export const getters = {
    perPage() {
        return USERS_PER_PAGE;
    },
    totalPages(state, getters) {
        return Math.ceil(state.total / getters.perPage);
    },
};
export const actions = {
    async loadUsers({ commit, state }) {
        commit('SET_LOADING', true);
        try {
            const result = await fetchResourceCollection(ApiResourceName.Users, this.$axios, state.page, [state.filters, USERS_FILTERS_MAPPING], [state.sorting, USERS_SORTING_MAPPING]);
            commit('SET_USERS', result.data);
            commit('SET_TOTAL', result.total);
        }
        catch (err) {
            Sentry.captureException(err);
            commit('SET_USERS', []);
            commit('SET_TOTAL', 0);
        }
        finally {
            commit('SET_LOADING', false);
        }
    },
    async changePage({ commit, dispatch }, page) {
        commit('SET_PAGE', page);
        await dispatch('loadUsers');
    },
    async filter({ commit, dispatch }, filters) {
        commit('SET_FILTERS', filters);
        await dispatch('loadUsers');
    },
    async sort({ commit, dispatch }, sorting) {
        commit('SET_SORTING', sorting);
        await dispatch('loadUsers');
    },
};
export const mutations = {
    SET_LOADING(state, loading) {
        state.loading = loading;
    },
    SET_USERS(state, users) {
        state.users.splice(0, state.users.length, ...users);
    },
    SET_TOTAL(state, total) {
        state.total = total;
    },
    SET_PAGE(state, page) {
        state.page = page;
    },
    SET_FILTERS(state, filters) {
        for (const key in filters)
            state.filters[key] = filters[key];
    },
    SET_SORTING(state, sorting) {
        state.sorting.by = sorting.by;
        state.sorting.direction = sorting.direction;
    },
    RESET_FILTERS(state) {
        for (const key in state.filters)
            state.filters[key] = undefined;
    },
    RESET_SORTING(state) {
        state.sorting.by = 'lastname';
        state.sorting.direction = SortDirection.Asc;
    },
};
